import TextArea from "../../../../Components/Common/TextArea/TextArea";
import { CHAR_LIMIT } from "../../../../utils/Common/Constant";

interface ResidentialNotesTabProps {
  generalNotes: string;
  drawNarrative: string;
  flaggedNotes: string;
  scheduleNotes: string;
  bankNotes: string;
  flaggedItems: string[];
  onGeneralNotesChange: (val: string) => void;
  onDrawNarrativeChange: (val: string) => void;
  onFlaggedNotesChange: (val: string) => void;
  onScheduleNotesChange: (val: string) => void;
  onBankNotesChange: (val: string) => void;
}

export default function ResidentialNotesTab({
  generalNotes,
  drawNarrative,
  flaggedNotes,
  scheduleNotes,
  bankNotes,
  flaggedItems,
  onGeneralNotesChange,
  onDrawNarrativeChange,
  onFlaggedNotesChange,
  onScheduleNotesChange,
  onBankNotesChange,
}: ResidentialNotesTabProps) {
  return (
    <>
      <div className="notesSection">
        <div className="notesSectionTitle">General Conditions &amp; Overview</div>
        <TextArea
          className="notesArea"
          placeholder="Overall observations, site conditions, weather, access…"
          rows={5}
          value={generalNotes}
          onChange={(e) => onGeneralNotesChange(e.target.value)}
          aria-label="General conditions notes"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>

      <div className="notesSection">
        <div className="notesSectionTitle">Draw Review Narrative</div>
        <TextArea
          className="notesArea"
          placeholder="Compare GC billing to observed progress. Note any discrepancies…"
          rows={4}
          value={drawNarrative}
          onChange={(e) => onDrawNarrativeChange(e.target.value)}
          aria-label="Draw review narrative"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>

      <div className="notesSection">
        <div className="notesSectionTitle">Flagged Items Summary</div>
        {flaggedItems.map((text, i) => (
          <div className="flagItem" key={i}>
            {text}
          </div>
        ))}
        <TextArea
          className="notesArea"
          placeholder="Add additional flag notes…"
          rows={3}
          value={flaggedNotes}
          onChange={(e) => onFlaggedNotesChange(e.target.value)}
          aria-label="Flag notes"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>

      <div className="notesSection">
        <div className="notesSectionTitle">Schedule &amp; Change Orders</div>
        <TextArea
          className="notesArea"
          placeholder="Schedule status, change orders, upcoming milestones…"
          rows={3}
          value={scheduleNotes}
          onChange={(e) => onScheduleNotesChange(e.target.value)}
          aria-label="Schedule and change orders notes"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>

      <div className="notesSection">
        <div className="notesSectionTitle">Items for Bank to Verify</div>
        <TextArea
          className="notesArea"
          placeholder="Bank action items…"
          rows={3}
          value={bankNotes}
          onChange={(e) => onBankNotesChange(e.target.value)}
          aria-label="Bank items to verify"
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
      </div>
    </>
  );
}
